import { compose, withProps, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { list } from 'ggApp/modules/category/selectors';

import Desktop from './Desktop';

const enhance = compose(
    connect(
        createStructuredSelector({
            categoryList: list,
        }),
    ),
    branch(({ categoryList }) => !categoryList.data, renderNothing),
    withProps(({ categoryList }) => ({
        categories: categoryList.data || null,
    })),
);

export default enhance(Desktop);
